export default __webpack_public_path__ + "static/media/hipCoronalMovement.aed40a31.png";